// Date and time format for charts
export const MINUTE_DATE_TIME_FORMAT = "mm";
export const HOURLY_DATE_TIME_FORMAT = "HH";
export const DAILY_DATE_TIME_FORMAT = "d-MMM";
export const WEEKLY_DATE_TIME_FORMAT = "d-MMM";
export const MONTHLY_DATE_TIME_FORMAT = "MMMM";
